import { sliceActions } from "./account.slice";

export const accountActions = {
  setInfoAccount: sliceActions.setInfoAccount,
};
